import reports from '../response/reports/reports.json';
import scheduledReportsList from '../response/reports/scheduled-report-list.json';
import scheduledReport from '../response/reports/scheduled-report.json';
import invoices from '../response/reports/invoices.json';
import reportTypesRaw from '../response/report-types.json';
import Env from 'Env';

// Feature flag: Filter EV Way4 reports when flag is disabled — evaluated inside
// each route handler so the flag is read at request time, not frozen at module load.
const getReportTypes = () =>
  Env.getIsEvWay4Enabled() ? reportTypesRaw : reportTypesRaw.filter((r) => r.reportTypeId !== '24');

export default function ReportRoutes() {
  // Get Reports
  this.get('reports-api/v1/reports/:grandParentAccountNumber/:contractIdentifier', () => reports);

  // Download Report
  this.get(
    'reports-api/v1/reports/invoicing/:grandParentAccountNumber/:contractIdentifier/downloadDocument/:documentId',
    () => {}
  );

  // Get Scheduled Reports List
  this.get('reports-api/v1/reports/:grandParentAccountNumber/:contractIdentifier/schedules', () => {
    // Feature flag: Hide EV Way4 scheduled reports when flag is disabled
    const filteredResults = Env.getIsEvWay4Enabled()
      ? scheduledReportsList.result
      : scheduledReportsList.result.filter((r) => r.reportTypeId !== '24');

    return {
      ...scheduledReportsList,
      result: filteredResults,
      resultSize: filteredResults.length,
    };
  });

  // Get Scheduled Report
  this.get(
    'reports-api/v1/reports/:grandParentAccountNumber/:contractIdentifier/schedules/:reportScheduleId',
    (schema, request) => {
      const reportScheduleId = parseInt(request.params.reportScheduleId);
      const scheduleFromList = scheduledReportsList.result.find((s) => s.reportScheduleID === reportScheduleId);

      if (scheduleFromList) {
        const reportType = getReportTypes().find((r) => r.reportTypeId === scheduleFromList.reportTypeId);
        return {
          ...scheduledReport,
          reportScheduleId: scheduleFromList.reportScheduleID,
          reportTypeId: scheduleFromList.reportTypeId,
          reportName: scheduleFromList.reportName,
          reportDescription: reportType?.reportDescription || scheduleFromList.reportDescription,
          outputFormat: scheduleFromList.outputType,
          isDisabled: scheduleFromList.isDisabled,
          reportSchedule: {
            ...scheduledReport.reportSchedule,
            scheduleFrequency: scheduleFromList.scheduleFrequency,
            reportingDayOfWeek: scheduleFromList.reportingDayOfWeek,
          },
        };
      }

      return scheduledReport;
    }
  );

  // Delete Scheduled Report
  this.delete(
    'reports-api/v1/reports/:grandParentAccountNumber/:contractIdentifier/schedules/:reportScheduleId',
    () => {}
  );

  // Enable Scheduled Report
  this.put(
    'reports-api/v1/reports/:grandParentAccountNumber/:contractIdentifier/schedules/:reportScheduleId/enable',
    () => {}
  );

  // Disable Scheduled Report
  this.put(
    'reports-api/v1/reports/:grandParentAccountNumber/:contractIdentifier/schedules/:reportScheduleId/disable',
    () => {}
  );

  // Create Scheduled Report
  this.post('reports-api/v1/reports/:grandParentAccountNumber/:contractIdentifier/schedules', () => {});

  // Update Scheduled Report
  this.put(
    'reports-api/v1/reports/:grandParentAccountNumber/:contractIdentifier/schedules/:reportScheduleId',
    () => {}
  );

  // Get Invoices
  this.get('reports-api/v1/reports/invoicing/:grandParentId/:accountNumber/invoices', () => invoices);
}
